<div [formGroup]="form" *ngIf="form">
    <div class="row">
        <div class="apc-form-card">
            <span class="title">{{'person.extras.metadata' | translate}}</span>
            <div class="container-fluid my-2">
                <div class="row">
                    <div class="form-group col-lg-6">
                        <apc-form-select formControlName="extraTypeIdentifier" [items]="typesDropdown" optionValue="identifier" [renderValue]="findDropdownRenderValue()" [isRequired]="true">
                            <label label>{{'person.extras.typology'  | translate}}</label>
                        </apc-form-select>
                    </div>
                    <div class="form-group col-lg-6">
                        <label>{{'person.extras.name' | translate}}</label>
                        <apc-form-input [class]="'form-control'" formControlName="linkName" [type]="'text'">
                        </apc-form-input>
                    </div>

                    <div class="form-group col-lg-12 mt-3">
                        <apc-form-input [class]="'form-control'" formControlName="value" [type]="'text'" [isRequired]="true">
                            <label label>{{'person.extras.url' | translate}}
                                <a *ngIf="form.value.value" [href]="form.value.value" target="_blank" class="url-icon">
                                    <div class="icon fill-black" aria-label="link" [inlineSVG]="'assets/ico/link.svg'"></div>
                                </a>
                            </label>
                        </apc-form-input>
                    </div>

                    <div class="form-group col-lg-12 mt-3">
                        <label>{{'person.extras.description' | translate}}</label>
                        <apc-form-input [class]="'form-control'" formControlName="description" [type]="'textarea'" [rows]="'4'">
                        </apc-form-input>
                    </div>
                </div>
            </div>
        </div>
    </div>